import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MfContainer from 'features/mf-container/';
import Authorize from 'features/authorize/';
import UserEntitledApps from 'features/user-entitled-apps';
import LogoutHandler from 'features/logout-handler';
import EmailVerify from 'features/email-verify/EmailVerify.component';
import SignInFlow from 'features/signin/SignInFlow.component';
import PrivateRoute from './privateRoute';

/**
 * Defines components to routes mapping.
 *
 * Everytime a new view is created, entry is required here to map the component to a specific route.
 *
 * [IMPORTANT]
 * All route entries are required to be done before the notFound component.
 *
 * @returns {XML}
 */
export default React.memo(() => (
  <Switch>
    <Route path="/authorize/callback" component={Authorize} />
    <Route path="/logout-handler" exact component={LogoutHandler} />
    <Route path="/verify" exact component={EmailVerify} />
    {/* #genai shared resource sign-in flow (single public route) */}
    <Route path="/signin" exact component={SignInFlow} />
    <PrivateRoute path="/start" component={UserEntitledApps} />
    <PrivateRoute path="/:appName" component={MfContainer} />
    <PrivateRoute path="/" component={MfContainer} />
    {/* <Route path="*" component={NotFound}/> */}
  </Switch>
));
